export const PREFIX_CACHE = 'WP_Aupd__';

/**
 * Функция для генерации уникального ключа на основе токена
 */
export const generateKeyByAuth = (token) => {
  /**
   * Берем последние 20 символов токена
   */
  return token.slice(-20)
}

/**
 * Формирование ключа localStorage
 * @param cacheName
 * @param auth
 */
export const generateKeyLocalStorage = (cacheName, auth) => {
  return `${cacheName}-${generateKeyByAuth(auth)}`
}

/**
 * Запись данных в localStorage
 * @param cacheKey
 * @param value
 */
export const storageSetDataByKey = (cacheKey, value) => {
  localStorage.setItem(`${PREFIX_CACHE}${cacheKey}`, JSON.stringify(value));
};

/**
 * Получение данных из localStorage
 * @param cacheKey
 */
export const storageGetDataByKey = (cacheKey) => {
  const item = localStorage.getItem(`${PREFIX_CACHE}${cacheKey}`);
  return item ? JSON.parse(item) : null;
};

/**
 * Удаление данных по ключу из localStorage
 * @param prefixRegex
 */
export const storageRemoveDataByKey = (prefixRegex) => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && prefixRegex.test(key)) {
      localStorage.removeItem(key);
      i--;
    }
  }
};

/**
 * Удаление данных в localStorage
 */
export const storageReset = () => {
  const prefixRegex = new RegExp(`^${PREFIX_CACHE}`);
  storageRemoveDataByKey(prefixRegex);
};
